import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, INLINES} from '@contentful/rich-text-types'
import {FAQ, InlineLink, OrderedList, Stack, Text, UnorderedList} from '@primer/react-brand'
import React from 'react'

import type {PrimerComponentFaq} from '../../../lib/types/contentful'

export type ContentfulFaqProps = {
  component: PrimerComponentFaq
}

export function ContentfulFaq({component}: ContentfulFaqProps) {
  return (
    <FAQ className="px-4">
      <FAQ.Heading>{component.fields.heading}</FAQ.Heading>

      {(component.fields.blocks ?? []).map((block, blockIndex) => (
        <React.Fragment key={blockIndex}>
          {block.fields.heading !== undefined && <FAQ.Subheading>{block.fields.heading}</FAQ.Subheading>}

          {(block.fields.questions ?? []).map(question => (
            <FAQ.Item key={question.sys.id}>
              <FAQ.Question>{question.fields.question}</FAQ.Question>

              <FAQ.Answer>
                <Stack direction="vertical" gap="condensed" padding="none">
                  {documentToReactComponents(question.fields.answer, {
                    renderNode: {
                      [BLOCKS.PARAGRAPH]: (_, children) => (
                        <Text as="p" size="300">
                          {children}
                        </Text>
                      ),
                      [BLOCKS.OL_LIST]: (_, children) => <OrderedList>{children}</OrderedList>,
                      [BLOCKS.UL_LIST]: (_, children) => <UnorderedList>{children}</UnorderedList>,
                      [BLOCKS.LIST_ITEM]: (_, children) => (
                        /**
                         * We ca use either UnorderedList.Item or OrderedList.Item here.
                         */
                        <UnorderedList.Item>{children}</UnorderedList.Item>
                      ),
                      [INLINES.HYPERLINK]: (node, children) => (
                        <InlineLink size="300" href={node.data.uri}>
                          {children}
                        </InlineLink>
                      ),
                    },
                  })}
                </Stack>
              </FAQ.Answer>
            </FAQ.Item>
          ))}
        </React.Fragment>
      ))}
    </FAQ>
  )
}

try{ ContentfulFaq.displayName ||= 'ContentfulFaq' } catch {}